import { ouvrirModaleVisuel } from '../producteur/ModaleVisuel'
import { ORANGE, VERT, fmtDateLongue, fmtHoraire, getInscriptionState } from './marcheProducer'

/**
 * Carte d'un evenement, facette producteur (S62) — UNE carte pour l'accueil et
 * l'onglet Évènements. Condensee (retour Daniel : l'ancienne prenait « trop
 * d'espace pour rien ») :
 *  - une ligne d'identite (tuile, nom, lieu · date · horaire) ;
 *  - l'etat du stand en une ligne de texte, pas un bandeau ;
 *  - UNE action principale, « Se desinscrire » en lien discret a cote.
 * `enAvant` : variante « prochain evenement » de l'accueil (libelle au-dessus,
 * tuile un peu plus grande) — remplace l'ancien hero sombre.
 */
export default function CarteEvenementProducteur({
  marche, participation, nbProduits, enAvant = false,
  retraitEnCours, onOuvrirFeuille, onDesinscrire,
}) {
  const confirme = !!participation?.standConfirmeAt
  const inscription = getInscriptionState(marche)
  const enRetrait = retraitEnCours === participation?.id
  const sousTitre = [marche.lieu, fmtDateLongue(marche.date), fmtHoraire(marche)].filter(Boolean).join(' · ')

  return (
    <div className={`glass-surface ${enAvant ? 'rounded-3xl p-4' : 'rounded-[22px] p-3.5'}`}>
      {enAvant && (
        <p className="text-[10px] font-extrabold uppercase tracking-[0.18em] mb-2" style={{ color: ORANGE }}>
          Prochain évènement
        </p>
      )}
      <div className="flex items-center gap-3">
        <span
          className={`${enAvant ? 'w-[52px] h-[52px] rounded-[16px] text-[26px]' : 'w-11 h-11 rounded-[14px] text-[22px]'} flex-shrink-0 flex items-center justify-center`}
          style={{ background: 'linear-gradient(135deg, rgb(var(--c-teal)), #0d6b5f)' }}
        >
          {marche.typeConfig?.icone || '🎪'}
        </span>
        <div className="flex-1 min-w-0">
          <p className={`font-serif leading-tight truncate ${enAvant ? 'text-[21px]' : 'text-[18px]'}`} style={{ color: VERT }}>
            {marche.nom || marche.lieu}
          </p>
          <p className="text-[12px] mt-0.5 text-ink/60 leading-snug">{sousTitre}</p>
          {confirme && (
            <p className="text-[12px] font-bold mt-1" style={{ color: '#0a6b52' }}>
              ✓ {typeof nbProduits === 'number' ? `${nbProduits} produit${nbProduits > 1 ? 's' : ''} ce jour-là` : 'Produits choisis pour ce jour'}
            </p>
          )}
          {participation && !confirme && (
            <p className="text-[12px] font-bold mt-1" style={{ color: ORANGE }}>Inscrit · produits à choisir</p>
          )}
        </div>
      </div>

      <div className="flex items-center gap-2 mt-3">
        {confirme ? (
          <button
            onClick={() => onOuvrirFeuille(marche, participation)}
            className="glass-surface flex-1 rounded-full text-[12.5px] font-bold py-2.5"
            style={{ border: '1px solid rgba(7,62,61,0.12)', color: VERT }}
          >
            Changer mes produits
          </button>
        ) : (
          <button
            onClick={() => onOuvrirFeuille(marche, participation)}
            className="flex-1 rounded-full text-[13px] font-extrabold py-3"
            style={{ background: ORANGE, color: VERT }}
          >
            {participation ? 'Choisir mes produits' : "M'inscrire"}
          </button>
        )}
        {participation && (
          <button
            onClick={() => ouvrirModaleVisuel({ evenementId: marche.id })}
            aria-label="Créer un visuel pour cet évènement"
            title="Créer un visuel à partager"
            className="glass-surface rounded-full text-[15px] px-3 py-2"
            style={{ border: '1px solid rgba(7,62,61,0.12)' }}
          >
            🖼️
          </button>
        )}
        {participation && inscription.canWithdraw && (
          <button
            onClick={() => onDesinscrire(marche, participation)}
            disabled={enRetrait}
            className="text-[12px] font-bold px-3 py-2.5 disabled:opacity-50"
            style={{ color: 'rgba(7,62,61,0.55)' }}
          >
            {enRetrait ? '…' : 'Se désinscrire'}
          </button>
        )}
      </div>
      {participation && !inscription.canWithdraw && (
        <p className="mt-1.5 text-[11px]" style={{ color: 'rgba(7,62,61,0.5)' }}>
          {inscription.label} — contactez Manrina pour vous désinscrire.
        </p>
      )}
    </div>
  )
}
